import { render, staticRenderFns } from "./example-page.vue?vue&type=template&id=328dd890&scoped=true&"
import script from "./example-page.vue?vue&type=script&lang=js&"
export * from "./example-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328dd890",
  null
  
)

export default component.exports